export interface TeacherRecord {
  id: string;
  teacherId: string;
  name: string;
  dob: string;
  role: string;
  className: string;
  dateOfJoining: string;
  contactNumber: string;
  email: string;
  address: string;
  district: string;
  town: string;
  status: 'active' | 'on-leave' | 'inactive';
  deactivatedAt?: string;
}

export const teacherRoles = [
  'Speech Therapist',
  'Special Educator',
  'Occupational Therapist',
  'Physiotherapist',
  'Clinical Psychologist',
  'Behaviour Therapist',
  'Art Therapist',
  'Music Therapist',
  'Play Therapist',
  'Counsellor',
  'Social Worker',
  'Audiologist',
  'Vision Specialist',
  'Vocational Trainer',
  'Assistant Teacher',
];

export const classSections = [
  'Pre Primary - A',
  'Pre Primary - B',
  'Primary - A',
  'Primary - B',
  'Secondary - A',
  'Secondary - B',
];

export const teachers: TeacherRecord[] = [
  {
    id: 'tch-001',
    teacherId: 'TCH-2024-001',
    name: 'Ms. Emily Watson',
    dob: '1988-04-15',
    role: 'Special Educator',
    className: 'Pre Primary - A',
    dateOfJoining: '2019-06-10',
    contactNumber: '+91 98123 45670',
    email: 'emily.watson@xlplatform.edu',
    address: '22, Green Park Colony, Near City Hospital',
    district: 'Nagpur',
    town: 'Nagpur Central',
    status: 'active',
  },
  {
    id: 'tch-002',
    teacherId: 'TCH-2024-002',
    name: 'Ms. Jennifer Lee',
    dob: '1991-09-22',
    role: 'Speech Therapist',
    className: 'Pre Primary - B',
    dateOfJoining: '2020-02-14',
    contactNumber: '+91 98123 45671',
    email: 'jennifer.lee@xlplatform.edu',
    address: '15A, Rose Garden Apartments, MG Road',
    district: 'Pune',
    town: 'Hadapsar',
    status: 'active',
  },
  {
    id: 'tch-003',
    teacherId: 'TCH-2024-003',
    name: 'Dr. Sarah Mitchell',
    dob: '1985-11-03',
    role: 'Clinical Psychologist',
    className: 'Primary - A',
    dateOfJoining: '2018-08-01',
    contactNumber: '+91 98123 45672',
    email: 'sarah.mitchell@xlplatform.edu',
    address: '7, Hill View Society, Near Sai Temple',
    district: 'Mumbai',
    town: 'Andheri East',
    status: 'active',
  },
  {
    id: 'tch-004',
    teacherId: 'TCH-2024-004',
    name: 'Mr. James Okafor',
    dob: '1990-03-28',
    role: 'Special Educator',
    className: 'Primary - B',
    dateOfJoining: '2021-01-20',
    contactNumber: '+91 98123 45673',
    email: 'james.okafor@xlplatform.edu',
    address: '33, Teachers Colony, Ring Road',
    district: 'Thane',
    town: 'Kalyan',
    status: 'active',
  },
  {
    id: 'tch-005',
    teacherId: 'TCH-2024-005',
    name: 'Ms. Emma Reyes',
    dob: '1992-07-14',
    role: 'Occupational Therapist',
    className: 'Secondary - A',
    dateOfJoining: '2020-09-05',
    contactNumber: '+91 98123 45674',
    email: 'emma.reyes@xlplatform.edu',
    address: '41, Shanti Nagar, Near Railway Station',
    district: 'Nashik',
    town: 'Nashik Road',
    status: 'active',
  },
  {
    id: 'tch-006',
    teacherId: 'TCH-2024-006',
    name: 'Mr. David Kumar',
    dob: '1987-12-10',
    role: 'Behaviour Therapist',
    className: 'Secondary - B',
    dateOfJoining: '2019-11-18',
    contactNumber: '+91 98123 45675',
    email: 'david.kumar@xlplatform.edu',
    address: '56, Vidya Nagar, Near Bus Stand',
    district: 'Amravati',
    town: 'Amravati Camp',
    status: 'on-leave',
  },
  {
    id: 'tch-007',
    teacherId: 'TCH-2024-007',
    name: 'Ms. Priya Nair',
    dob: '1993-05-06',
    role: 'Art Therapist',
    className: 'Pre Primary - A',
    dateOfJoining: '2022-03-01',
    contactNumber: '+91 98123 45676',
    email: 'priya.nair@xlplatform.edu',
    address: '89, Laxmi Nagar, Ward No. 4',
    district: 'Nagpur',
    town: 'Dharampeth',
    status: 'active',
  },
  {
    id: 'tch-008',
    teacherId: 'TCH-2024-008',
    name: 'Mr. Arjun Desai',
    dob: '1989-08-19',
    role: 'Physiotherapist',
    className: 'Primary - A',
    dateOfJoining: '2021-07-12',
    contactNumber: '+91 98123 45677',
    email: 'arjun.desai@xlplatform.edu',
    address: '12, Banjara Hills, Road No. 3',
    district: 'Solapur',
    town: 'Solapur Central',
    status: 'active',
  },
  {
    id: 'tch-009',
    teacherId: 'TCH-2024-009',
    name: 'Ms. Fatima Sheikh',
    dob: '1994-02-25',
    role: 'Counsellor',
    className: 'Secondary - A',
    dateOfJoining: '2022-08-15',
    contactNumber: '+91 98123 45678',
    email: 'fatima.sheikh@xlplatform.edu',
    address: '78, Juhu Tara Road, Opposite Beach Garden',
    district: 'Mumbai',
    town: 'Juhu',
    status: 'active',
  },
  {
    id: 'tch-010',
    teacherId: 'TCH-2024-010',
    name: 'Mr. Ravi Menon',
    dob: '1986-06-11',
    role: 'Music Therapist',
    className: 'Pre Primary - B',
    dateOfJoining: '2020-04-22',
    contactNumber: '+91 98123 45679',
    email: 'ravi.menon@xlplatform.edu',
    address: '64, Ganesh Colony, Behind Post Office',
    district: 'Pune',
    town: 'Shivaji Nagar',
    status: 'active',
  },
  {
    id: 'tch-011',
    teacherId: 'TCH-2024-011',
    name: 'Ms. Ananya Gupta',
    dob: '1995-10-30',
    role: 'Play Therapist',
    className: 'Primary - B',
    dateOfJoining: '2023-01-10',
    contactNumber: '+91 98123 45680',
    email: 'ananya.gupta@xlplatform.edu',
    address: '19, Sakura Lane, Near Sai Mandir',
    district: 'Nagpur',
    town: 'Sitabuldi',
    status: 'active',
  },
  {
    id: 'tch-012',
    teacherId: 'TCH-2024-012',
    name: 'Mr. Vikram Rao',
    dob: '1984-01-08',
    role: 'Social Worker',
    className: 'Secondary - B',
    dateOfJoining: '2018-05-30',
    contactNumber: '+91 98123 45681',
    email: 'vikram.rao@xlplatform.edu',
    address: '3, Swami Vivekanand Marg, Old City',
    district: 'Aurangabad',
    town: 'CIDCO',
    status: 'inactive',
    deactivatedAt: '2024-12-10',
  },
  {
    id: 'tch-013',
    teacherId: 'TCH-2024-013',
    name: 'Ms. Kavita Joshi',
    dob: '1992-12-04',
    role: 'Audiologist',
    className: 'Pre Primary - A',
    dateOfJoining: '2021-11-08',
    contactNumber: '+91 98123 45682',
    email: 'kavita.joshi@xlplatform.edu',
    address: '27, Rosewood Apartments, Central Avenue',
    district: 'Nagpur',
    town: 'Wardha Road',
    status: 'active',
  },
  {
    id: 'tch-014',
    teacherId: 'TCH-2024-014',
    name: 'Mr. Sanjay Patil',
    dob: '1988-09-17',
    role: 'Vision Specialist',
    className: 'Primary - A',
    dateOfJoining: '2020-06-25',
    contactNumber: '+91 98123 45683',
    email: 'sanjay.patil@xlplatform.edu',
    address: '51, Sai Krupa Building, Station Road',
    district: 'Amravati',
    town: 'Badnera',
    status: 'on-leave',
  },
  {
    id: 'tch-015',
    teacherId: 'TCH-2024-015',
    name: 'Ms. Lakshmi Iyer',
    dob: '1993-07-21',
    role: 'Vocational Trainer',
    className: 'Secondary - B',
    dateOfJoining: '2022-02-14',
    contactNumber: '+91 98123 45684',
    email: 'lakshmi.iyer@xlplatform.edu',
    address: '9, Teachers Colony, Ring Road',
    district: 'Solapur',
    town: 'Solapur Central',
    status: 'active',
  },
  {
    id: 'tch-016',
    teacherId: 'TCH-2024-016',
    name: 'Mr. Carlos Menezes',
    dob: '1990-04-03',
    role: 'Assistant Teacher',
    className: 'Pre Primary - B',
    dateOfJoining: '2023-06-01',
    contactNumber: '+91 98123 45685',
    email: 'carlos.menezes@xlplatform.edu',
    address: '44, Hill View Society, Near Central Park',
    district: 'Thane',
    town: 'Dombivli',
    status: 'active',
  },
  {
    id: 'tch-017',
    teacherId: 'TCH-2024-017',
    name: 'Ms. Neha Kapoor',
    dob: '1991-11-12',
    role: 'Special Educator',
    className: 'Secondary - A',
    dateOfJoining: '2021-09-20',
    contactNumber: '+91 98123 45686',
    email: 'neha.kapoor@xlplatform.edu',
    address: '35, Vidya Vihar Colony, Near Bus Depot',
    district: 'Nashik',
    town: 'Panchavati',
    status: 'active',
  },
  {
    id: 'tch-018',
    teacherId: 'TCH-2024-018',
    name: 'Mr. Rohit Verma',
    dob: '1987-05-29',
    role: 'Speech Therapist',
    className: 'Primary - B',
    dateOfJoining: '2019-03-15',
    contactNumber: '+91 98123 45687',
    email: 'rohit.verma@xlplatform.edu',
    address: '71, Green Park Colony, Near City Hospital',
    district: 'Pune',
    town: 'Kothrud',
    status: 'active',
  },
];